const workDetails = [
    {
        id: 1,
        name: 'Red Onion Foods',
        description: [
            'MERN project for a food delivery service or restaurant.',
            'Provides different menu for breakfast, lunch and dinner.',
            'Built with ReactJS, Material-UI, Bootstrap, ExpressJS, Firebase auth.'
        ],
        category: 'fullStack',
        image: 'Red-Onion-Foods.png',
        github: 'https://github.com/BK-Bagchi/red-onion-restaurent',
        liveSite: 'https://the-red-onion-foods.web.app/'
    },
    {
        id: 2,
        name: 'The Ultimate Traveller',
        description: [
            'ReactJS based front-end project showing different travel destination.',
            'User selects his travel destination and fills the information form.',
            'Built with ReactJS, Material-UI, Bootstrap, Firebase auth.'
        ],
        category: 'frontEnd',
        image: 'The-Ultimate-Traveller.png',
        github: 'https://github.com/BK-Bagchi/the-ultimate-traveler',
        liveSite: 'https://the-ultimate-traveler.web.app/'
    },
    {
        id: 6,
        name: 'Volunteer Network',
        description: [
            'MERN project with real-time database shows different volunteering options.',
            'User selects any work and register for the volunteering.',
            'User has his own dashboard to see his selected works.',
        ],
        category: 'fullStack',
        image: 'Volunteer-Network.png',
        github: 'https://github.com/BK-Bagchi/the-ultimate-traveler',
        liveSite: 'https://the-ultimate-traveler.web.app/'
    },
    {
        id: 7,
        name: 'Creative Agency',
        description: [
            'Full-stack project with different feature for software or design firm.',
            'User can order a work, review on work, see order condition from dashboard.',
            'Admin can see all order list, add new feature and admin from dashboard.',
        ],
        category: 'fullStack',
        image: 'creative-agency.png',
        github: 'https://github.com/BK-Bagchi/the-ultimate-traveler',
        liveSite: 'https://the-ultimate-traveler.web.app/'
    },
    {
        id: 3,
        name: 'React E-School',
        description: [
            'React based web application shows components on screen using API data.',
            'Calls different APIs, manages data in client side and shows an organized view.',
            'Built with ReactJS, React Router, Material-UI, Bootstrap.'
        ],
        category: 'frontEnd',
        image: 'React-E-School.png',
        github: 'https://github.com/BK-Bagchi/react-e-school',
        liveSite: 'https://eschool-react.netlify.app/'
    },
    {
        id: 4,
        name: 'Social Buddy',
        description: [
            'React based web application shows components on screen using API data.',
            'Calls different APIs, manages data in client side and shows an organized view.',
            'Built with ReactJS, React Router, Material-UI, Bootstrap.'
        ],
        category: 'frontEnd',
        image: 'Social-Buddy.png',
        github: 'https://github.com/BK-Bagchi/social-buddy',
        liveSite: 'https://social-dude.netlify.app/'
    },
    {
        id: 5,
        name: 'That Pixabay Traveller',
        description: [
            'React based web application shows components on screen using API data.',
            'Calls different APIs, manages data in client side and shows an organized view.',
            'Built with ReactJS, React Router, Material-UI, Bootstrap.'
        ],
        category: 'frontEnd',
        image: 'That-Pixabay-Traveller.png',
        github: 'https://github.com/BK-Bagchi/that-pixabay-traveler',
        liveSite: 'https://bk-bagchi.github.io/that-pixabay-traveler/'
    },
]

export default workDetails